import type { HorarioAtencion } from '@barbones/shared';
import { useQuery } from '@tanstack/react-query';
import { api } from '@/api/cliente';
import { useSesion } from '@/api/sesion';
import { useBarberos } from './datos';

// Aparte de `datos.ts`: usa la sesión, y `datos.ts` lo importan módulos (caja, reportes) que no deben cargarla.
export type { HorarioAtencion };

/**
 * Con barbero: su horario de ese día, de la lista de barberos del día (la agenda del día no trae a los demás
 * a quien solo ve su propia agenda); `'descanso'` si no viene en ella (descansa o no tiene horario).
 * Sin barbero: apertura y cierre de la sucursal. `undefined` mientras carga.
 */
export function useHorarioAtencion(barberoId: string | null, dia: string): HorarioAtencion | 'descanso' | undefined {
  const { sucursalId } = useSesion();
  const barberos = useBarberos(dia);
  const sucursales = useQuery({
    queryKey: ['sucursales'],
    queryFn: () => api<{ id: string; apertura: string; cierre: string }[]>('/sucursales'),
    staleTime: 300_000,
  });
  if (!barberoId) {
    const s = sucursales.data?.find((x) => x.id === sucursalId);
    return s ? { nombre: null, entrada: s.apertura, salida: s.cierre, comidaInicio: null, comidaFin: null } : undefined;
  }
  if (!barberos.data) return undefined;
  const b = barberos.data.find((x) => x.id === barberoId);
  if (!b?.horario) return 'descanso';
  return { nombre: b.nombre, ...b.horario };
}

